<template>
    <div classs="peomonitor">
        <div class="monitor_center">
            <div class="block lf">
                <el-select v-model="region" ref='mySelect'>
                    <el-option :value="region" style="height:0" ></el-option>
                    <el-tree :data="viewList" :props="defaultProps" @node-click="nodeclick" ref='tree' node-key="id"></el-tree>
                </el-select>
          
            </div>
            <div class="monitor_btn rf com_task" >
                <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;" @change="radiocount">
                    <el-radio-button :label="ix" :key="ix" v-for="(item,ix) in inGlist" >{{ix=='0'?'总考试人员('+item+')':ix=='1'?'及格人员('+item+')':ix=='3'?'不及格人员('+item+')':ix=='2'?'满分人员('+item+')':ix=='4'?'未考人员('+item+')':ix=="5"?'待阅卷人员('+item+')':ix=="7"?'补考人员('+item+')':'缺考人员('+item+')'}}</el-radio-button>
                </el-radio-group>
            </div>
            
        </div>
        <el-table :data="taskList" border style="width: 100%" class="exam_table"
        ref="multipleTable"
        >
        <el-table-column
            v-for="info in tHeadr" :key="info.key"     
            :property="info.key"
            :label="info.label"
            :width="info.width"
        >
        <template slot-scope="scope">
            {{scope.row[scope.column.property]}}  <!-- 渲染对应表格里面的内容 -->
        </template>
        </el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope" class="exam_btn">
                <el-button type="text" size="large" @click="hrefTo(scope)" v-if="scope.row.num!='0'">查看详情</el-button>
                <el-button type="text" size="large" v-else disabled>查看详情</el-button>
            </template>
        </el-table-column>
        </el-table>
        <page :count="count" :curpage.sync='page' @pagenation='pagetion'></page>
    </div>
</template>
<script>
import page from '../Common/page'
export default{
    name:'peomonitor',
    data(){
        return{
            taskList:[],
            inGlist:[],
            region:'',
            isCollapse: 0,
            value:'',
            options:[],
            secid:0,
            limit:10, //一页几条数据
            bmid:0,
            radioup:['all','1','3','2','0','5','4','6'],
            page:1, 
            tHeadr: [
                {
                    label: '人员',
                    key: 'nickname',
                    width:'160'
                },
                {
                    label: '所属部门',
                    key: 'dep',
                    width:'756  '
                },
                {
                    label: '考试结果',
                    key: 'states',
                    width:'165'
                },
                {
                    label:'考试次数',
                    key:'num',
                    width:'170'
                },
                {
                    label:'考试得分',
                    key:'grade',
                    width:'157'
                },
            ],
            id:this.$route.query.id,
            viewList:[],
            defaultProps: {
                children: 'son',
                label: 'sec_name'
            }
        }
    },
    components:{
        page,
    },
    props:{
         taskListSear:{
            type:Array,
            default:()=>[],
        },
        count:{
            type:Number,
            default:0
        },
        searchtxt:{
            type:String,
            default:''
        }
    },
    
    watch:{
        taskListSear(){
            this.taskList=this.taskListSear
        }
    },
    methods:{
        hrefTo(id){
            console.log(id)
            var tid= id.row.user_id
            var eid= id.row.t_id
            this.$router.push({ path:'/examRecord',query:{id:tid,eid:eid}})
        },
        radiocount(e){
            console.log(this.radioup[e])
            this.page=1
            this.taskList=[]
            var data={
            service:'Examtask.Examlog1',
            id:this.id,
            search:this.radioup[e],
            limit:this.limit,
            page:1,
            // userid:localStorage.getItem('userid')
            userid: 21343
            }
            var tklist=[]
            this.$axios.post(this.HOME,this.$qs.stringify(data))
            .then(res=>{
                if(res.data.data.code==0){
                    this.count=parseInt(res.data.data.info.count)
                    for(var i=0;i<res.data.data.info.list.length;i++){
                        tklist.push(res.data.data.info.list[i])
                    }
                     for(var x=0;x<tklist.length;x++){
                        if(tklist[x].num>"1"){
                            tklist[x].grade=tklist[x].grade+'(补考)'
                        }
                    }
                    this.taskList=tklist
                    this.taskList=tklist
                }
                else{
                    this.count=1
                    this.alertView.failView(res.data.data.msg)
                    
                }
            })
        },
        nodeclick(data){
            this.$refs.mySelect.handleClose();
            this.region=data.sec_name
            this.secid=data.sec_id
            var data={
                service:'Examtask.Examlog1',
                id:this.id,
                dept:data.sec_id,
                limit:this.limit,
                page:this.page,
                // userid:localStorage.getItem('userid')
                userid: 21343
            }
            console.log(this.secid)
            this.$axios.post(this.HOME,this.$qs.stringify(data))
                .then(res=>{
                    var tklist =[],
                    num =[]
                    if(res.data.data.code == 1){
                        this.alertView.failView('没有数据')
                        this.taskList = []
                    this.count=1
                        return false
                    }
                    this.count=res.data.data.info.count
                    for(var i=0;i<res.data.data.info.list.length;i++){
                    
                        console.log(res.data.data.info.list[i])
                        tklist.push(res.data.data.info.list[i])
                    }
                    var jsonStr =res.data.data.info.num
                    for(var a=1;a<8;a++){
                        num.push(jsonStr[a])
                    }
                     for(var x=0;x<tklist.length;x++){
                        if(tklist[x].num>"1"){
                            tklist[x].grade=tklist[x].grade+'(补考)'
                        }
                    }
                    this.taskList=tklist
                    this.inGlist=num
                    this.taskList=tklist
                })
            },
        pagetion(limit,page){
            this.page=page
             var data={
                service:'Examtask.Examlog1',
                id:this.id,
                limit:limit,
                dept:this.secid,
                nickname:this.searchtxt,
                page:page,
                search:this.radioup[this.isCollapse],
                // userid:localStorage.getItem('userid')
                userid: 21343
            }
            var  tklist=[]
             this.$axios.post(this.HOME,this.$qs.stringify(data))
                .then(res=>{
                    this.count=parseInt(res.data.data.info.count)
                    for(var i=0;i<res.data.data.info.list.length;i++){
                        
                        tklist.push(res.data.data.info.list[i])
                    }
                     for(var x=0;x<tklist.length;x++){
                        if(tklist[x].num>"1"){
                            tklist[x].grade=tklist[x].grade+'(补考)'
                        }
                    }
                    this.taskList=tklist
                })
        }
    },
    mounted(){
        var data={
            service:'Examtask.Examlog1',
            id:this.id,
            limit:this.limit,
            page:this.page,
            // userid:localStorage.getItem('userid')
            userid: 21343
        }
        var data1={
            service:'Examtask.Examlog1',
            id:this.id,
            limit:this.limit,
            page:this.page,
            // userid:localStorage.getItem('userid')
            userid: 21343
        }
        var datalist={
            service:'Examtask.Admininfo',
        }
        var list =[
            {
                sec_id:0,
                sec_name:'全部',
                sec_pid:1
            }
        ]
        var tklist=[]
        var num =[]
        this.$axios.post(this.HOME,this.$qs.stringify(data1))
        .then(res => {
            console.log("-----", res.data.data)
        })
        this.$axios.post(this.HOME,this.$qs.stringify(data))
        .then(res=>{
            console.log("***", res.data.data)
            for(var i=0;i<res.data.data.info.list.length;i++){
                tklist.push(res.data.data.info.list[i])
            }
            var jsonStr =res.data.data.info.num
            for(var a=1;a<9;a++){
                num.push(jsonStr[a])
            }
            this.inGlist=num
            for(var x=0;x<tklist.length;x++){
                if(tklist[x].num>"1"){
                    tklist[x].grade=tklist[x].grade+'(补考)'
                }
            }
            this.taskList=tklist
        this.count=parseInt(res.data.data.info.count)
        })
        this.$axios.post(this.HOME,this.$qs.stringify(datalist))
        .then(res=>{
            for(var i=0;i<res.data.data.length;i++){
                list.push(res.data.data[i])
            }
            this.viewList=list
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/task/peomonitor.vue